export default "__VITE_ASSET__CyIRl1wM__"